__turbopack_context__.v({
  "className": "tRRzaW_className",
  "variable": "tRRzaW_variable",
});
